import React from "react";
import { Link, NavLink } from "react-router-dom"; // NavLink peut être utile pour le style actif
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap'; // Importez les composants nécessaires

import nyicon1x from "./images/ny-icone-1x.png";
import nyicon2x from "./images/ny-icone-2x.png";
import ny1x from "./images/ny-1x.png";
import ny2x from "./images/ny-2x.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faCalendarAlt,
  faImages,
  faCommentDots,
  faImage,
  faSquare,
  faPortrait,
  // faBars n'est plus nécessaire ici, Navbar.Toggle s'en charge
} from "@fortawesome/free-solid-svg-icons";

import "./Menu.css"; // Gardez vos styles CSS

function Menu() {
  const navLinkId = "responsive-navbar-nav"; // ID pour lier Toggle et Collapse

  return (
    // Utilisez le composant Navbar de react-bootstrap
    // expand="md" : le menu se transforme en burger sur les écrans plus petits que 'md'
    // collapseOnSelect : referme le menu après un clic sur un lien (pratique sur mobile)
    <Navbar expand="md" bg="transparent" variant="dark" collapseOnSelect className="mt-0 pt-0 mt-sm-1 pt-sm-1 mt-md-2 pt-md-2 mt-lg-2 pt-lg-2">
      {/* Container peut aider à gérer la largeur */}
      <Container fluid>
        {/* Navbar.Brand pour le logo/signature */}
        <Navbar.Brand as={Link} to="/" id="signature"> {/* Utilisez 'as={Link}' pour intégrer react-router */}
          <img
            src={nyicon1x}
            alt="Ny"
            className="img-fluid"
            sizes="(min-width: 454px) 45px, 30px"
            srcSet={`${nyicon1x} 43w, ${nyicon2x} 87w`}
          />
          &nbsp;&nbsp;
          <img
            src={ny1x}
            alt="Ny signature"
            className="img-fluid signature-image"
            sizes="(min-width: 454px) 289px, 175px"
            srcSet={`${ny1x} 289w, ${ny2x} 586w`}
          />
        </Navbar.Brand>

        {/* Navbar.Toggle gère le bouton burger */}
        <Navbar.Toggle aria-controls={navLinkId}>
           {/* Vous pouvez personnaliser l'icône si nécessaire, mais react-bootstrap fournit une icône par défaut */}
           {/* Si vous voulez garder FontAwesome: <FontAwesomeIcon icon={faBars} className="navbar-toggler-icon-white" /> */}
        </Navbar.Toggle>

        {/* Navbar.Collapse contient les éléments qui doivent être masqués/affichés */}
        <Navbar.Collapse id={navLinkId}>
          {/* Utilisez Nav pour la liste des liens */}
          <Nav className="ms-auto align-items-center"> {/* ms-auto pour aligner à droite */}
            {/* Utilisez Nav.Link, potentiellement avec 'as={NavLink}' de react-router-dom pour le style actif */}
            <Nav.Link as={NavLink} to="/" className="ny-menu-item ps-0 pe-0 pe-sm-1 pe-md-2 pe-lg-3">
              <FontAwesomeIcon icon={faHome} className="mx-2" />
              Accueil
            </Nav.Link>
            <Nav.Link as={NavLink} to="/expos" className="ny-menu-item ps-0 pe-0 pe-sm-1 pe-md-2 pe-lg-3">
              <FontAwesomeIcon icon={faCalendarAlt} className="mx-2" />
              Actualités
            </Nav.Link>

            {/* Utilisez NavDropdown pour le menu déroulant */}
            <NavDropdown
              title={
                <>
                  <FontAwesomeIcon icon={faImages} className="mx-2" />
                  Tableaux&nbsp;
                </>
              }
              id="basic-nav-dropdown"
              className="ny-menu-item pe-3" // Appliquez la classe au NavDropdown
            >
              <NavDropdown.Item as={Link} to="/tableaux-l" className="ny-menu-item">
                <FontAwesomeIcon icon={faImage} className="mx-2" />
                en largeur
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/tableaux-c" className="ny-menu-item">
                <FontAwesomeIcon icon={faSquare} className="mx-2" />
                carrés
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/tableaux-h" className="ny-menu-item">
                <FontAwesomeIcon icon={faPortrait} className="mx-2" />
                en hauteur
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={NavLink} to="/contact" className="ny-menu-item ps-0 pe-0 pe-sm-1 pe-md-2 pe-lg-3 me-2">
              <FontAwesomeIcon icon={faCommentDots} className="mx-2" />
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Menu;